import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/../CAP_VUE_BUNDLE/capAssetsBundle/images/Logo_cap.png'


const _withScopeId = n => (_pushScopeId("data-v-5a09d66c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "logo"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "CAP PERFORMANCE"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_hourglass = _resolveComponent("q-spinner-hourglass")!

  return (_ctx.isPending)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["routerPending", _ctx.isFirstLoading ? 'firstLoading' : ''])
      }, [
        (_ctx.isFirstLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true),
        _createVNode(_component_q_spinner_hourglass, {
          color: "white",
          size: "4em",
          class: "spinner"
        })
      ], 2))
    : _createCommentVNode("", true)
}